import { locationSelector, useHudStore } from "@/domains/hud/store";
import HudLocation from "@/domains/hud/components/HudLocation";

export default function HudLocationContainer() {
  const location = useHudStore(locationSelector);

  if (!location) return null;

  return <HudLocation {...location} />;
}
